import type { ReportComponent } from '@mathflat/domain/Report'
import type { ListedWorkbook } from '@mathflat/domain/Workbook'
import type { WorksheetTag } from '@mathflat/domain/Worksheet'
import { WORKSHEET_TAG, WORKSHEET_TAG_KO } from '@mathflat/domain/Worksheet'

import commonRepo from '@/repository/common.repo'

export const WORKSHEET_TAGS: ReadonlyArray<{ key: WorksheetTag; label: string }> =
  WORKSHEET_TAG.map((key) => ({ key, label: WORKSHEET_TAG_KO[key] }))

/**
 * 교재 타입 목록
 */
export const WORKBOOK_TYPES = [
  {
    key: 'CUSTOM',
    label: '내교재',
  },
  {
    key: 'ACADEMY_GROUP',
    label: '학원그룹교재',
  },
  {
    key: 'PUBLIC',
    label: '시중교재',
  },
  {
    key: 'SCHOOL',
    label: '교과서',
  },
  {
    key: 'CUSTOM_SIGNATURE',
    label: '시그니처교재',
  },
] as ReadonlyArray<{ key: ListedWorkbook['type']; label: string }>

export type V2ReportSection = {
  key: ReportComponent
  label: string
  hasSubOption?: boolean
  subOption?: {
    key: ReportComponent
    label: string
  }
}

export const V2_REPORT_CONTENT_SECTIONS: ReadonlyArray<V2ReportSection> = [
  {
    key: 'COVER',
    label: '표지',
  },
  {
    key: 'MONTHLY',
    label: '월간분석',
    hasSubOption: true,
    subOption: {
      key: 'COMMENT',
      label: '선생님의견',
    },
  },
  {
    key: 'WEEKLY',
    label: '주간분석',
    hasSubOption: true,
    subOption: {
      key: 'LEVEL',
      label: '난이도별분석',
    },
  },
  {
    key: 'STUDY_HISTORY',
    label: '학습내역',
  },
  {
    key: 'STUDY_PERFORMANCE',
    label: '학습성과',
  },
  {
    key: 'SCORING_RESULT',
    label: '진단결과',
  },
  {
    key: 'STUDY_EVALUATION',
    label: '학습평가',
  },
] as const

/**
 * V2 보고서 컴포넌트 키 목록 (1차원 배열)
 * 메인 섹션 키 + 서브옵션 키를 모두 포함
 */
export const V2_REPORT_COMPONENT_KEYS: ReadonlyArray<ReportComponent> =
  V2_REPORT_CONTENT_SECTIONS.flatMap((section) =>
    section.subOption ? [section.key, section.subOption.key] : [section.key],
  )

export const USAGE_OPTIONS = [
  { key: 'USED', label: '사용' },
  { key: 'NOT_USED', label: '미사용' },
] as const

export const COMPARISON_OPTIONS = [
  { key: 'NATIONAL', label: '전국 동일 학년 평균', shortLabel: '전국' },
  {
    key: 'GRADE',
    get label() {
      return `${commonRepo.agencyNameInKor} 내 동일 학년 평균`
    },
    shortLabel: '학년',
  },
  {
    key: 'LESSON_CLASS',
    get label() {
      return `${commonRepo.agencyNameInKor} 내 동일 반 평균`
    },
    shortLabel: '반',
  },
  { key: 'NOT_USED', label: '미사용', shortLabel: '미사용' },
] as const

export type UsageOptionKey = (typeof USAGE_OPTIONS)[number]['key']
export type ComparisonOptionKey = (typeof COMPARISON_OPTIONS)[number]['key']
